import { FormObjType } from "DataTypes/Form";

export const VitalForm: FormObjType[] = [
  {
    id: "vitalSignDatetime",
    label: "Vital Sign Date",
    placeholder: "Select Vital Sign Date",
    boxType: "date-time",
    boxSize: 3,
    validatetype: "date",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "vitalName",
    label: "Vital Name",
    placeholder: "Enter Vital Name",
    boxType: "input",
    boxSize: 3,
    validatetype: "name",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "vitalValue",
    label: "Vital Value",
    placeholder: "Enter Vital Value",
    boxType: "input",
    boxSize: 3,
    validatetype: "name",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "vitalUnits",
    label: "Vital Unit",
    placeholder: "Enter Vital Unit",
    boxType: "input",
    boxSize: 3,
    validatetype: "name",
    required: true,
    enableFormLoad: true,
  },
]